import styled from 'styled-components';
import { themeGet } from 'styled-system';

export const StyledQuote = styled.blockquote`
  font-size: 3rem;
  text-align: center;
  font-style: italic;
  padding: 10%;
  color: ${themeGet('color.4')};
`;
